import React from 'react'

import { buildImageObj, getImageSizeFromRef, getPaddingFromAspectRatio } from '../../lib/helpers'
import { imageUrlFor } from '../../lib/image-url'
import styles from './figure.module.css'

function Figure (props) {
  // ! Cannot set default boolean value in Sanity
  // need to check for empty boolean in `props.shadow`
  const imageDimensions = getImageSizeFromRef(props.asset._ref)
  return (
    <figure
      className={styles.root} style={{
        paddingTop: getPaddingFromAspectRatio(imageDimensions.aspectRatio)
      }}
    >
      {props.asset && (
        <img
          className={props.shadow !== false ? styles.imageShadow : ''}
          loading='lazy'
          // TODO add jpeg as a fallback
          src={imageUrlFor(buildImageObj(props))
            .width(1200)
            .maxHeight(600)
            .url()}
          alt={props.alt || ''}
        />
      )}
      <figcaption className={styles.caption}>{props.caption}</figcaption>
    </figure>
  )
}

export default Figure
